import React from 'react';
import css from './ShareButtons.module.css';
import { FaInstagram, FaWhatsapp, FaFacebook } from 'react-icons/fa';
import {
  FacebookShareButton,
  WhatsappShareButton,
  FacebookIcon,
  WhatsappIcon
} from 'react-share';

const ShareButtons = ({ url, title, description, imageUrl, intl, isDropdown = false }) => {
  const handleInstagramShare = async () => {
    try {
      await navigator.clipboard.writeText(url);

      const instagramUrl = 'https://www.instagram.com/';
      window.open(instagramUrl, '_blank');
    } catch (error) {
      window.open('https://www.instagram.com/', '_blank');
    }
  };

  if (isDropdown) {
    return (
      <div className={css.dropdownContainer}>
        <WhatsappShareButton
          url={url}
          title={`${title}\n\n${description}`}
          separator=""
          className={css.dropdownItemWithText}
        >
          <div className={css.iconWrapper}>
            <WhatsappIcon size={32} round />
          </div>
          <span>{intl?.formatMessage({ id: 'ShareButtons.shareOnWhatsapp' })}</span>
        </WhatsappShareButton>

        {/* <FacebookShareButton
          url={url}
          quote={`${title} - ${description}`}
          hashtag="#AcheiBrasil"
          className={css.dropdownItemWithText}
        >
          <div className={css.iconWrapper}>
            <FacebookIcon size={32} round />
          </div>
          <span>{intl?.formatMessage({ id: 'ShareButtons.shareOnFacebook' })}</span>
        </FacebookShareButton> */}

        <button
          className={css.dropdownItemWithText}
          onClick={handleInstagramShare}
          type="button"
        >
          <div className={css.iconWrapper}>
            <div className={css.instagramButtonDropdown}>
              <FaInstagram size={20} />
            </div>
          </div>
          <span>{intl?.formatMessage({ id: 'ShareButtons.shareOnInstagram' })}</span>
        </button>
      </div>
    );
  }

  return (
    <div className={css.shareContainer}>
      <WhatsappShareButton url={url} title={`${title}\n\n${description}`} separator="">
        <WhatsappIcon size={40} round />
      </WhatsappShareButton>

      {/* <FacebookShareButton url={url} quote={`${title} - ${description}`} hashtag="#AcheiBrasil">
        <FacebookIcon size={40} round />
      </FacebookShareButton> */}

      <button
        className={css.instagramButton}
        onClick={handleInstagramShare}
        title={intl.formatMessage({ id: 'ShareButtons.shareOnInstagram' })}
        type="button"
      >
        <div className={css.instagramIcon}>
          <FaInstagram size={20} />
        </div>
      </button>
    </div>
  );
};

export default ShareButtons;
